// AI-CONTEXT: See docs/features/participation-ladder.md
import deriveParticipationStep from './deriveParticipationStep'

/**
 * @typedef {object} LadderSteps
 * @property {number|null} begin - Trede van de beginsituatie (1-6), of null als die niet is ingevuld
 * @property {number|null} current - Trede van de huidige situatie (1-6), of null
 * @property {number|null} change - Verschil in treden; null zolang een van beide ontbreekt (niet 0: dat leest als "niet veranderd")
 */

const step = (value) => (Number.isFinite(value) ? value : null)

/**
 * Begintrede, huidige trede en het verschil. Eén regel voor het tabblad
 * (calculateParticipationDelta) en de rapportagewidget, die op de openbare
 * link alleen de twee treden van de server krijgt.
 *
 * @param {number|null|undefined} begin
 * @param {number|null|undefined} current
 * @returns {LadderSteps}
 */
const ladderSteps = (begin, current) => {
    const b = step(begin)
    const c = step(current)
    return { begin: b, current: c, change: b !== null && c !== null ? c - b : null }
}

/**
 * @param {{t0?: object, t1?: object}|undefined} participation - `Personas.Participation`
 * @returns {LadderSteps}
 */
export const ladderStepsFromParticipation = (participation) =>
    ladderSteps(
        deriveParticipationStep(participation?.t0 || {}),
        deriveParticipationStep(participation?.t1 || {})
    )

export default ladderSteps
